import React, { useState } from "react";
import styles from "../styles/GetInTouchV2.module.css";

const API_URL =
  "https://apis.8-insights.com/internal/website/website-form-lead-submission";

const GetInTouchV2 = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [detectingCity, setDetectingCity] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleDetectCity = () => {
    if (!navigator.geolocation) {
      setStatus({
        type: "error",
        message: "Location detection is not supported in this browser.",
      });
      return;
    }

    setDetectingCity(true);
    setStatus({ type: "", message: "" });

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          const res = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
          );
          const data = await res.json();

          const locality = data.locality || "";
          const cityName = data.city || "";
          const state = data.principalSubdivision || "";
          const country = data.countryName || "";

          let fullAddress = "";
          if (locality) fullAddress += locality;
          if (cityName) fullAddress += (fullAddress ? ", " : "") + cityName;
          if (state) fullAddress += (fullAddress ? ", " : "") + state;
          if (country) fullAddress += (fullAddress ? ", " : "") + country;

          if (fullAddress) {
            setFormData((p) => ({ ...p, location: fullAddress }));
          } else {
            setStatus({ type: "error", message: "Unable to detect your address." });
          }
        } catch (err) {
          console.error(err);
          setStatus({
            type: "error",
            message: "Could not fetch city from location. Please try again.",
          });
        } finally {
          setDetectingCity(false);
        }
      },
      (error) => {
        console.error(error);
        setStatus({
          type: "error",
          message: "Permission denied or location unavailable.",
        });
        setDetectingCity(false);
      },
      { timeout: 10000 }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });

    if (!formData.name || !formData.email) {
      setStatus({ type: "error", message: "Name and Email are required." });
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
          location: formData.location,
          page: "home",
        }),
      });

      const data = await res.json();

      if (res.ok && data.success) {
        const msg =
          "Thank you for contacting 8 Insights. Your message has been received and our team will get back to you shortly.";

        setStatus({ type: "success", message: msg });
        setFormData({ name: "", email: "", phone: "", location: "", message: "" });
        setShowModal(true);
      } else {
        setStatus({
          type: "error",
          message: data.message || "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setStatus({
        type: "error",
        message: "Unable to submit right now. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className={`section-8i ${styles["git2-section"]}`}>
      <div className={`container-8i ${styles["git2-wrap"]}`}>

        <div className={`section-header text-center ${styles["git2-sectionHeader"]}`}>
            <h4 className="section-title">Get In <span> Touch </span></h4>
            <h6 className="section-sub-heading">
                One stop solutions for strategy, design, SEO and technology.
                Fill out the form and we’ll connect with you.
            </h6>
         </div>



        <div className={styles["git2-grid"]}>
          {/* LEFT: Collage */}
          <div className={styles["git2-collage"]} data-aos="fade-up">
            <div className={styles["git2-collageInner"]}>
              {/* Replace these 4 images with your own */}
              <div className={`${styles["git2-photo"]} ${styles["git2-photo1"]}`}>
                <img
                  src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=800&q=70"
                  alt="Team moment"
                  loading="lazy"
                />
              </div>

              <div className={`${styles["git2-photo"]} ${styles["git2-photo2"]}`}>
                <img
                  src="https://images.unsplash.com/photo-1551836022-deb4988cc6c0?auto=format&fit=crop&w=800&q=70"
                  alt="Collaboration"
                  loading="lazy"
                />
              </div>

              <div className={`${styles["git2-photo"]} ${styles["git2-photo3"]}`}>
                <img
                  src="https://images.unsplash.com/photo-1556761175-4b46a572b786?auto=format&fit=crop&w=800&q=70"
                  alt="Workshop"
                  loading="lazy"
                />
              </div>

              <div className={`${styles["git2-photo"]} ${styles["git2-photo4"]}`}>
                <img
                  src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=800&q=70"
                  alt="Discussion"
                  loading="lazy"
                />
              </div>


              
            </div>
          </div>

          {/* RIGHT: Form Card */}
          <div className={styles["git2-card"]} data-aos="fade-up" data-aos-delay="150">
            {/* <div className={styles["git2-cardHead"]}>
              <h4 className="section-title">Get In Touch</h4>
              <h6 className="section-sub-heading">
                One stop solutions for strategy, design, SEO and technology. Fill out the form
                and we’ll connect with you.
              </h6>
            </div> */}

            <form className={styles["git2-form"]} onSubmit={handleSubmit}>
              <div className={styles["git2-field"]}>
                <label className={styles["git2-label"]}>Name *</label>
                <input
                  className={styles["git2-input"]}
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  placeholder="Your name"
                />
              </div>

              <div className={styles["git2-field"]}>
                <label className={styles["git2-label"]}>Email *</label>
                <input
                  className={styles["git2-input"]}
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  placeholder="you@company.com"
                />
              </div>

              <div className={styles["git2-row2"]}>
                <div className={styles["git2-field"]}>
                  <label className={styles["git2-label"]}>Mobile</label>
                  <input
                    className={styles["git2-input"]}
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    disabled={loading}
                    placeholder="+1 5555 654 321"
                  />
                </div>

                <div className={styles["git2-field"]}>
                  <label className={styles["git2-label"]}>City</label>
                  <div className={styles["git2-locationWrap"]}>
                    <input
                      className={styles["git2-input"]}
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                      disabled={loading || detectingCity}
                      placeholder="Detect or type"
                    />
                    <button
                      type="button"
                      className={styles["git2-locateBtn"]}
                      onClick={handleDetectCity}
                      disabled={loading || detectingCity}
                      aria-label="Detect my city"
                      title="Detect my city"
                    >
                      <i className="bi bi-geo-alt-fill" />
                    </button>
                  </div>
                </div>
              </div>

              <div className={styles["git2-field"]}>
                <label className={styles["git2-label"]}>Comment</label>
                <textarea
                  className={styles["git2-textarea"]}
                  name="message"
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  disabled={loading}
                  placeholder="Tell us briefly what you need..."
                />
              </div>

              {status.type === "error" && (
                <p className={styles["git2-error"]}>{status.message}</p>
              )}

              <div className={styles["git2-actions"]}>
                <button className="btn-primary-8i" type="submit" disabled={loading}>
                  {loading ? "Sending..." : "Submit Now"}
                  <span aria-hidden="true" className={styles["git2-arrow"]}>→</span>
                </button>

                {/* Optional: secondary quick-action (like “Course Enquiry” style) */}
                {/* <button type="button" className={styles["git2-floatAction"]}>
                  <i className="bi bi-telephone-fill" /> Quick Call
                </button> */}
              </div>

              {status.type === "success" && !showModal && (
                <p className={styles["git2-successInline"]}>{status.message}</p>
              )}
            </form>
          </div>
        </div>
      </div>

      {showModal && status.type === "success" && (
        <div className={styles["git2-modalOverlay"]}>
          <div className={styles["git2-modal"]}>
            <div className={styles["git2-modalIcon"]}>✓</div>
            <h3 className={styles["git2-modalTitle"]}>Message sent successfully</h3>
            <p className={styles["git2-modalText"]}>{status.message}</p>
            <button
              className="btn-primary-8i"
              onClick={() => setShowModal(false)}
              type="button"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default GetInTouchV2;
